module.exports = __webpack_public_path__ + "img/wrenchBlack.2dfe2309.png";